var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_130",
    style: {},
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 7,
    width: 30,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.285 7c-3.268 0-6.116 1.846-7.608 4.574-.025.06-.062.128-.11.208a8.88 8.88 0 0 0-.304.652c-.19.522-.337 1.172-.451 1.8a25.86 25.86 0 0 0-.243 1.68l-.001.02h-.003a1.43 1.43 0 0 0-.006.055c-.028 2.15-1.738 3.886-3.844 3.886-2.124 0-3.846-1.764-3.846-3.941 0-2.178 1.722-3.942 3.846-3.942a3.79 3.79 0 0 1 2.783 1.221 10.425 10.425 0 0 1 2.216-4.197c.072-.082.146-.16.219-.238a8.538 8.538 0 0 0-5.22-1.78C4.903 7 1 11 1 15.935c0 4.934 3.902 8.93 8.716 8.933h.008c4.222 0 7.73-3.054 8.537-7.178.057-.29.102-.584.13-.883h.001l.002-.027a8.79 8.79 0 0 0 .03-.424c.01-.124.025-.268.044-.421.056-.48.154-1.06.319-1.5a4.62 4.62 0 0 1 .248-.475c.69-1.151 1.893-1.967 3.252-1.967 2.123 0 3.845 1.764 3.845 3.942 0 2.177-1.722 3.941-3.845 3.941a3.792 3.792 0 0 1-2.783-1.221 10.444 10.444 0 0 1-2.437 4.435 8.546 8.546 0 0 0 5.22 1.778c4.813 0 8.715-4 8.715-8.933C31 11 27.098 7 22.285 7z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_130)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.285 7c-3.268 0-6.116 1.846-7.608 4.574-.025.06-.062.128-.11.208a8.88 8.88 0 0 0-.304.652c-.19.522-.337 1.172-.451 1.8a25.86 25.86 0 0 0-.243 1.68l-.001.02h-.003a1.43 1.43 0 0 0-.006.055c-.028 2.15-1.738 3.886-3.844 3.886-2.124 0-3.846-1.764-3.846-3.941 0-2.178 1.722-3.942 3.846-3.942a3.79 3.79 0 0 1 2.783 1.221 10.425 10.425 0 0 1 2.216-4.197c.072-.082.146-.16.219-.238a8.538 8.538 0 0 0-5.22-1.78C4.903 7 1 11 1 15.935c0 4.934 3.902 8.93 8.716 8.933h.008c4.222 0 7.73-3.054 8.537-7.178.057-.29.102-.584.13-.883h.001l.002-.027a8.79 8.79 0 0 0 .03-.424c.01-.124.025-.268.044-.421.056-.48.154-1.06.319-1.5a4.62 4.62 0 0 1 .248-.475c.69-1.151 1.893-1.967 3.252-1.967 2.123 0 3.845 1.764 3.845 3.942 0 2.177-1.722 3.941-3.845 3.941a3.792 3.792 0 0 1-2.783-1.221 10.444 10.444 0 0 1-2.437 4.435 8.546 8.546 0 0 0 5.22 1.778c4.813 0 8.715-4 8.715-8.933C31 11 27.098 7 22.285 7z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoo);
export default __webpack_public_path__ + "static/media/HOO.647dad9695c8d63e4491155f7585df8f.svg";
export { ForwardRef as ReactComponent };